module.exports = __webpack_public_path__ + "media/images/favicon-7fadc47b12494429100967d09b01666e.png";